import { render } from "./InputFile.vue?vue&type=template&id=bd86d4e4&scoped=true&ts=true"
import script from "./InputFile.vue?vue&type=script&lang=ts"
export * from "./InputFile.vue?vue&type=script&lang=ts"

import "./InputFile.vue?vue&type=style&index=0&id=bd86d4e4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd86d4e4"]])

export default __exports__